<template>
  <el-button
      v-bind="$attrs"
      :disabled="!table || $attrs.disabled"
      @click="copyTableData"
  >
    {{ label }}
  </el-button>
</template>

<script>
import { ElMessage } from 'element-plus';

export default {
  name: 'CopyTableButton',
  inheritAttrs: false, // 防止属性自动绑定到根元素上
  props: {
    table: {
      type: Object,
      required: true,
      default: null
    },
    label: {
      type: String,
      default: '复制表格'
    }
  },
  methods: {
    copyTableData() {
      if (!this.table) {
        ElMessage.error('未提供有效的表格实例');
        return;
      }
      const columns = this.table.columns.filter(col => col.property);
      if (!columns.length) {
        ElMessage.error('表格没有有效的列定义');
        return;
      }
      const headers = columns.map(col => col.label || '');
      const headerRow = headers.join('\t');
      const props = columns.map(col => col.property);
      const data = this.table.data || [];
      if (!data.length) {
        ElMessage.warning('表格数据为空');
        return
      }
      const dataRows = data
          .map(row => {
            return props
                .map(prop => {
                  const value = row[prop] ?? '';
                  return String(value).replace(/\t/g, ' ').replace(/\n/g, ' ');
                })
                .join('\t');
          })
          .join('\n');
      const tableText = dataRows ? `${headerRow}\n${dataRows}` : headerRow;
      navigator.clipboard.writeText(tableText)
          .then(() => {
            ElMessage.success('表格数据已复制，可进入WPS进行粘贴');
          })
          .catch(err => {
            ElMessage.error('复制失败');
            console.error('复制失败:', err);
          });
    }
  }
};
</script>